var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPrimaryOrgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 768,
    viewBox: "0 0 1120 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 768,
    fill: "#F6F7F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E4E8EF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 60,
    width: 910,
    height: 648
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 156,
    width: 680,
    height: 490
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 60L220 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015 60L900 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 708L220 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015 708L900 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 156L900 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 646L900 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 156L220 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 156L900 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 220L220 270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 450L220 425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015 220L900 270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015 450L900 425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 60L390 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 60L510 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 60L610 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 60L700 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 708L390 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 708L510 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 708L610 646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 708L700 646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrimaryOrgGrid);
export default __webpack_public_path__ + "static/media/no-primary-org-grid.2525143c8384774af17becc770a02e8d.svg";
export { ForwardRef as ReactComponent };